"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sassocorvaro-auditore": {
    "b5d556bc": [{
      "hkey": "47920e8b",
      "slug": "san-giovanni",
      "name": "San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "castelnuovo-san-giovanni": [{
      "hkey": "47920e8b",
      "slug": "san-giovanni",
      "name": "San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "de6e7ed9": [{
      "hkey": "0f699cc0",
      "slug": "fontanelle-san-leo-nuovo",
      "name": "Fontanelle-San Leo Nuovo",
      "primary": true,
      "skipSearch": false
    }],
    "fontanelle": [{
      "hkey": "0f699cc0",
      "slug": "fontanelle-san-leo-nuovo",
      "name": "Fontanelle-San Leo Nuovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "73f3c7ff": [{
      "hkey": "f6e22e58",
      "slug": "piagnano",
      "name": "Piagnano",
      "primary": true,
      "skipSearch": false
    }],
    "piagniano": [{
      "hkey": "f6e22e58",
      "slug": "piagnano",
      "name": "Piagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ab443ee0": [{
      "hkey": "0f699cc0",
      "slug": "fontanelle-san-leo-nuovo",
      "name": "Fontanelle-San Leo Nuovo",
      "primary": true,
      "skipSearch": false
    }],
    "san-leo-nuovo": [{
      "hkey": "0f699cc0",
      "slug": "fontanelle-san-leo-nuovo",
      "name": "Fontanelle-San Leo Nuovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sassocorvaro-auditore"
    }]
  }
};
exports["default"] = _default;